import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { GeneralModule } from '../../modules/general.module';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatHeaderCell, MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { YubiDialog } from '../_index';

@NgModule({
    exports: [YubiDialog],
    imports: [
        CommonModule,
        FormsModule,
        GeneralModule,
        MatDialogModule,
        MatTooltipModule,
        MatTabsModule,
        MatButtonModule,
        MatSlideToggleModule,
        MatCheckboxModule,
        MatInputModule,
        MatFormFieldModule,
        MatSelectModule,
        MatRadioModule,
        MatTableModule
    ],
    declarations: [YubiDialog],
    providers: [],
    entryComponents: []
})

export class YubiDialogModule { }
